class SearchSchoolpack extends HTMLElement {
    constructor() {
        super();

        this.addtocartItemsQuantity = 0;
        this.controller = null;
        this.focusedIndex = -1;
    }

    connectedCallback() {
        this.schoolpackSearchForm = this.querySelector('.schoolpack-collection__search');
        if (!this.schoolpackSearchForm) return false;

        this.schoolnameSearchInputField = this.querySelector('#search__school-name');
        if (!this.schoolnameSearchInputField) return false;

        this.schoolpackCollections = this.querySelector('#collections__schoolpack-json');
        if (!this.schoolpackCollections) return false;

        this.schoolpackDropdownOptions = this.querySelector('#collectionSearchDropdown');
        this.collectionSchoolResults = this.querySelector('.collection-school-results');
        this.initSchoolpackSearchForm();

    }

    disconnectedCallback() {
        if (this.controller) {
            this.controller.abort();
        }
    }

    initSchoolpackSearchForm() {
        this.searchSchoolpack();
        this.searchSubmit();
        this.showStickyFooter();
    }

    searchSchoolpack() {
        const schoolpackCollections = JSON.parse(this.schoolpackCollections.textContent);

        // Search Schoolpack
        this.schoolnameSearchInputField.addEventListener('input', async () => {
            const query = this.schoolnameSearchInputField.value.trim();

            if (query.length < 2) {
                this.schoolpackDropdownOptions.innerHTML = '';
                this.schoolpackDropdownOptions.classList.remove('show-dropdown');
                return;
            }

            if (this.controller) this.controller.abort();
                this.controller = new AbortController();

            try {
                // const response = await fetch(
                //     `/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=collection`,
                //     { signal: this.controller.signal }
                // );

                // const data = await response.json();
                // const collections = data.resources.results.collections;

                const querySchoolpackCollections = schoolpackCollections.collections.filter(collection => {
                    return collection.title.toLowerCase().includes(query.toLowerCase());
                }).map(collection => {
                    return {
                        title: collection.title,
                        handle: collection.handle
                    };
                });

                this.schoolpackDropdownOptions.innerHTML = '';
                this.focusedIndex = -1;

                if (!querySchoolpackCollections.length) {
                    this.schoolpackDropdownOptions.classList.remove('show-dropdown');
                    return false;
                }

                querySchoolpackCollections.forEach(collection => {
                    const li = document.createElement('li');
                    li.innerHTML = collection.title;
                    li.dataset.collectionHandler = collection.handle;
                    li.dataset.collectionTitle = collection.title;
                    this.schoolpackDropdownOptions.appendChild(li);
                });
                this.schoolpackDropdownOptions.classList.add('show-dropdown');

            } catch (e) {
                console.error(e);
            }
        });

        // Schoolpack Dropdown Handler
        if (this.schoolpackDropdownOptions) {
            this.schoolpackDropdownOptions.addEventListener('click', (e) => {
                const option = e.target.closest('li');
                if (!option) return false;
                this.selectItem(option);
            });
        }

        // Keyboard navigation
        this.schoolnameSearchInputField.addEventListener('keydown', (e) => {
            const items = this.schoolpackDropdownOptions.querySelectorAll('li');
            if (!items.length || !this.schoolpackDropdownOptions.classList.contains('show-dropdown')) return false;

            if (e.key === 'ArrowDown') {
                e.preventDefault();
                this.focusedIndex = (this.focusedIndex + 1) % items.length;
                this.setFocus(items);
            } else if (e.key === 'ArrowUp') {
                e.preventDefault();
                this.focusedIndex = (this.focusedIndex - 1 + items.length) % items.length;
                this.setFocus(items);
            } else if (e.key === 'Enter') {
                e.preventDefault();
                if (this.focusedIndex >= 0) this.selectItem(items[this.focusedIndex]);
            }
        });

        // Exit dropdown
        document.addEventListener('click', (e) => {
            if (!e.target.closest('.schoolpack-collection__search')) {
                this.schoolpackDropdownOptions.classList.remove('show-dropdown');
            }
        });
    }
    
    // Set dropdown option on focus
    setFocus(items) {
        items.forEach((li, i) => {
            li.classList.toggle('focused', i === this.focusedIndex);
        });
    }

    // Select dropdown option
    selectItem(item) {
        this.schoolnameSearchInputField.value = item.textContent.trim();
        this.schoolpackDropdownOptions.classList.remove('show-dropdown');
        this.focusedIndex = -1;
        this.setInstrumentOptions(item);
    }

    // Load Instruments list onto Instrument Dropdown Field
    async setInstrumentOptions(item) {
        const instrumentSearchInputField = this.querySelector('#search__instrument');
        const instrumentOptions = new Set();
        this.productList = new Set();

        try {
            const res = await fetch(`/collections/${item.dataset.collectionHandler}/products.json?limit=250`);
            const data = await res.json();

            data.products.forEach(product => {
                product.tags.forEach(tag => {
                    if (tag.toLowerCase().startsWith(`schoolpackessential:${item.dataset.collectionTitle}`)) {
                        this.productList.add(product);
                    }
                    if (tag.toLowerCase().startsWith('instrument:')) {
                        instrumentOptions.add(tag.replace(/^instrument:/i, ''));
                        this.productList.add(product);
                    }
                });
            });
        } catch (e) {
            console.error(e);
        }

        if (!instrumentOptions.size) {
            instrumentSearchInputField.innerHTML = '<option value="">No instrument options found</option>';
            return false;
        }

        // Add instrument options to dropdown field
        const customSortOrder = ['violin', 'viola', 'cello', 'double bass'];
        instrumentSearchInputField.innerHTML = '';
        [...instrumentOptions]
            .sort((a, b) => {
                const ai = customSortOrder.indexOf(a.toLowerCase());
                const bi = customSortOrder.indexOf(b.toLowerCase());
                return (ai === -1 ? Infinity : ai) - (bi === -1 ? Infinity : bi);
            })
            .forEach(inst => {
                const option = document.createElement('option');    
                option.value = inst;
                option.textContent = inst;
                instrumentSearchInputField.appendChild(option);
            });

        if (this.productList.size) {
            this.setSizeOptions(instrumentSearchInputField.value);
        }

        instrumentSearchInputField.addEventListener('change', (e) => {
            this.setSizeOptions(e.target.value);
        });
    }

    // Load Instrument sizes list onto Size Dropdown Field
    async setSizeOptions(instrument) {
        const sizeSearchInputField = this.querySelector('#search__size');
        const sizes = new Set();

        // Filter product list based on selected instrument
        const filteredInstrumentList = [...this.productList].filter(product => {
            return product.tags.some(tag => {
                return tag.toLowerCase().startsWith(`instrument:${instrument.toLowerCase()}`);
            });
        });

        if (!filteredInstrumentList.length) {
            sizeSearchInputField.innerHTML = '<option value="">No size options found</option>';
            return false;
        }

        // Viola (uses inches)
        if (instrument.toLowerCase().includes('viola')) {
            filteredInstrumentList.forEach(product => {
                product.tags.forEach(tag => {
                    if (tag.toLowerCase().startsWith('size:') && tag.toLowerCase().includes('"')) {
                        sizes.add(tag.replace(/^size:/i, ''));
                    }
                });
            });
        } else {
            // All instruments except viola
            const sortedSizes = new Set();
            filteredInstrumentList.forEach(product => {
                product.tags.forEach(tag => {
                    if (tag.toLowerCase().startsWith('size:') && !tag.toLowerCase().includes('"')) {
                        sortedSizes.add(tag.replace(/^size:/i, ''));
                    }
                });
            });

            // Sort numerically by fractional value
            [...sortedSizes].sort((a, b) => this.fractionToNumber(a) - this.fractionToNumber(b)).forEach(size => {
                sizes.add(size);
            });
        }

        if (!sizes.size) {
            sizeSearchInputField.innerHTML = '<option value="">No size options found</option>';
            return false;
        }

        // Add size options to dropdown field
        sizeSearchInputField.innerHTML = '<option value="">All</option>';
        [...sizes].forEach(size => {
            const option = document.createElement('option');
            option.value = size;
            option.textContent = size;
            sizeSearchInputField.appendChild(option);
        });
    }

    searchSubmit() {
        this.querySelector('#search__submit-button').addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.productList.size) return false;
            if (!this.collectionSchoolResults) return false;

            // Value of search input fields
            const selectedInstrument = this.querySelector('#search__instrument').value;
            const selectedSize = this.querySelector('#search__size').value;

            // Filtered out essential products
            const nonGenericEssentialProductList = new Set();
            const nonEssentialInstrumentProductList = new Set();

            // Identify results div
            this.searchResultItems = this.querySelector('.school-result-item-list');
            if (!this.searchResultItems) return false;
            this.searchResultItems.innerHTML = '';

            // Set result heading description
            const resultHeadingDescription = this.querySelector('.result-heading-description');
            if (resultHeadingDescription) {
                const size = selectedSize || 'All Sizes';
                resultHeadingDescription.innerHTML = `
                    <div>School Name: <span>${this.schoolnameSearchInputField.value}</span></div>
                    <div>Instrument: <span>${selectedInstrument}</span></div>
                    <div>Size: <span>${size}</span></div>
                `;
            }

            // Add Generic Essential Product
            [...this.productList].sort((a, b) => a.title.localeCompare(b.title)).forEach(product => {
                // Skip product with instrument tag
                const hasInstrumentTag = product.tags.some(tag =>
                    tag.toLowerCase().startsWith('instrument:')
                );
                if (hasInstrumentTag) {
                    nonGenericEssentialProductList.add(product);
                    return false;
                }

                const isEssentialProduct = product.tags.some(tag =>
                    tag.toLowerCase().startsWith(
                        `schoolpackessential:${this.schoolnameSearchInputField.value.toLowerCase()}`
                    )
                );
                if (!isEssentialProduct) {
                    nonGenericEssentialProductList.add(product);
                    return false;
                }

                // Add generic essential product to result
                if (product.variants.length > 1) {
                    this.addProductToResult(product, true, true);
                }
                if (product.variants.length === 1) {
                    this.addProductToResult(product, false, true);
                }
            });

            // Product related to selected instrument (without generic essential products)
            [...nonGenericEssentialProductList].sort((a, b) => a.title.localeCompare(b.title)).forEach(product => {
                const isInstrumentProduct = product.tags.some(tag =>
                    tag.toLowerCase().startsWith('instrument:') &&
                        selectedInstrument === tag.replace(/^instrument:/i, '')
                );
                const isEssentialInstrumentProduct = product.tags.some(tag =>
                    tag.toLowerCase().startsWith(
                        `schoolpackessential:${this.schoolnameSearchInputField.value.toLowerCase()}`
                    )
                );

                // Add essential instrument product to result
                if (isInstrumentProduct && isEssentialInstrumentProduct) {
                    if (product.variants.length > 1) {
                        this.addProductToResult(product, true, true);
                    }
                    if (product.variants.length === 1) {
                        this.addProductToResult(product, false, true);
                    }
                    return false;
                }
                
                if (isInstrumentProduct && !isEssentialInstrumentProduct) {
                    nonEssentialInstrumentProductList.add(product);
                }
            });

            // Filter product list based on selected size
            if (!selectedSize) {
                // Include product from all sizes
                [...nonEssentialInstrumentProductList].sort((a, b) => a.title.localeCompare(b.title)).forEach(product => {
                    if (product.variants.length > 1) {
                        this.addProductToResult(product, true, false);
                    }
                    if (product.variants.length === 1) {
                        this.addProductToResult(product, false, false);
                    }
                });
            } else {
                // Add product from selected size
                [...nonEssentialInstrumentProductList].sort((a, b) => a.title.localeCompare(b.title)).forEach(product => {
                    const isSizeProduct = product.tags.some(tag => tag.toLowerCase().startsWith('size:'));
                    
                    if (isSizeProduct) {
                        // Select correct size variant for product that has multiple size variants
                        const isSelectedSizeProduct = product.tags.some(tag =>
                            tag.toLowerCase().startsWith('size:') &&
                            selectedSize === tag.replace(/^size:/i, '')
                        );
                        if (!isSelectedSizeProduct) return false;

                        if (product.variants.length > 1) {
                            const isSelectedSizeVariant = (variant, selectedSizeValue) => {
                                if (!variant?.title || !selectedSizeValue) return false;
                                let selectedValue = selectedSizeValue;
                                
                                const isInches = selectedSizeValue.includes('"');
                                if (isInches) {
                                    const inchToFractionMap = {
                                        '11"': '1/4',
                                        '12"': '1/2',
                                        '13"': '3/4',
                                        '14"': '4/4',
                                    };
                                    selectedValue = inchToFractionMap[selectedSizeValue];
                                }

                                selectedValue = this.fractionToNumber(selectedValue);
                                const sizePart = variant.title;

                                if (sizePart.includes('-')) {
                                    const [min, max] = sizePart.split('-').map(v =>
                                        this.fractionToNumber(v.trim())
                                    );
                                    return selectedValue >= min && selectedValue <= max;
                                }
                                return selectedValue === this.fractionToNumber(sizePart);
                            };
                            
                            product.variants.forEach(variant => {
                                if (isSelectedSizeVariant(variant, selectedSize)) {
                                    this.addProductToResult(product, false, false, variant);
                                }
                            });
                            return;
                        }

                        if (product.variants.length === 1) {
                            this.addProductToResult(product, false, false);
                        }
                    } else {
                        if (product.variants.length > 1) {
                            this.addProductToResult(product, true, false);
                        }
                        if (product.variants.length === 1) {
                            this.addProductToResult(product, false, false);
                        }
                    }
                });
            }

            // Show result section
            this.showSchoolPackResultSection();
            // Initial calculation
            this.calculateTotal();
            this.setItemQuantity();
            // Add All Selected to Cart
            this.addAllSelectedToCart();
            // Return to School Search
            this.returnToSchoolSearch();
        });
    }

    addProductToResult(product, hasMultipleVariants=false, isEssential=false, targetVariant=null) {
        // Product details
        const productImage = product.images[0].src;
        const productId = product.variants[0].id;
        const productTitle = product.title;
        const productPrice = product.variants[0].price;

        // Create search result item
        const searchResultItem = document.createElement('li');
        searchResultItem.classList.add('school-result-item');
        searchResultItem.dataset.productId = productId;
        searchResultItem.dataset.productQuantity = 1;
        searchResultItem.dataset.productPrice = productPrice;

        // Add essential class if product is essential
        if (isEssential) {
            searchResultItem.classList.add('essential-item');
        }

        if (targetVariant) {
            const variantImage = targetVariant.featured_image?.src || productImage;
            searchResultItem.dataset.productId = targetVariant.id;
            searchResultItem.dataset.productPrice = targetVariant.price;
            searchResultItem.innerHTML = `
                <div class="item-image">
                    <img src="${variantImage}" alt="${product.title} - ${targetVariant.title}" width="100" height="100">
                </div>
                <div class="item-title">
                    <span>${product.title} ${targetVariant.title}</span>
                    ${isEssential ? `
                        <span class="essential-item__tag">
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8101 5.79558C15.7316 5.53688 15.496 5.35427 15.2133 5.32384L10.8473 4.8521L9.02548 0.971663C8.7899 0.484706 7.95753 0.484706 7.73766 0.971663L5.91586 4.8521L1.54984 5.32384C1.26715 5.35427 1.04728 5.53688 0.953044 5.79558C0.874519 6.05427 0.937339 6.32818 1.15721 6.51079L4.40817 9.38688L3.51298 13.5717C3.45016 13.8304 3.5601 14.1043 3.79567 14.2717C4.01554 14.4238 4.32965 14.4391 4.56522 14.3173L8.38157 12.2021L12.1979 14.3021C12.3079 14.363 12.4335 14.3934 12.5434 14.3934C12.6848 14.3934 12.8418 14.3477 12.9675 14.2564C13.1873 14.1043 13.2973 13.8304 13.2502 13.5564L12.3707 9.38688L15.6059 6.52601C15.8101 6.3434 15.8886 6.05427 15.8101 5.79558ZM11.1143 8.64123C10.9258 8.80862 10.8473 9.0521 10.8944 9.28036L11.5383 12.3543L8.72708 10.8173C8.61715 10.7564 8.49151 10.726 8.38157 10.726C8.27163 10.726 8.14599 10.7564 8.03606 10.8173L5.22484 12.3543L5.86875 9.28036C5.91586 9.03688 5.83734 8.7934 5.64888 8.64123L3.2617 6.52601L6.48125 6.17601C6.73253 6.14558 6.9367 5.9934 7.04663 5.78036L8.38157 2.91949L9.71651 5.78036C9.82644 5.9934 10.0306 6.14558 10.2819 6.17601L13.5014 6.52601L11.1143 8.64123Z" fill="white" stroke="#E69D2E" stroke-width="0.2"/>
                            </svg>
                        REQUIRED</span>
                    ` : ''}
                </div>
                <div class="item-amount">
                    <div class="item-price">$${targetVariant.price}</div>
                    <div class="item-quantity">
                        <div class="product-quantity-input">
                            <button data-id="${targetVariant.id}" class="product-quantity-adjust product-quantity-input-minus" type="button">&minus;</button>
                            <input type="number" id="updates_${targetVariant.id}" pattern="[0-9]*" aria-label="quantity" data-id="${targetVariant.id}" value="1" class="product-quantity-number schoolpack-product-qty-input">
                            <button data-id="${targetVariant.id}" class="product-quantity-adjust product-quantity-input-plus" type="button">+</button>
                        </div>
                    </div>
                </div>
            `;
            this.searchResultItems.appendChild(searchResultItem);
            return;
        }

        // Add product with multiple variants
        if (hasMultipleVariants) {
            product.variants.sort((a, b) => this.fractionToNumber(a.title) - this.fractionToNumber(b.title)).forEach(variant => {
                const searchResultItemVariant = document.createElement('li');
                searchResultItemVariant.classList.add('school-result-item');
                const variantImage = variant.featured_image?.src || productImage;
                searchResultItemVariant.dataset.productId = variant.id;
                searchResultItemVariant.dataset.productQuantity = 1;
                searchResultItemVariant.dataset.productPrice = variant.price;
                searchResultItemVariant.innerHTML = `
                    <div class="item-image">
                        <img src="${variantImage}" alt="${product.title} - ${variant.title}" width="100" height="100">
                    </div>
                    <div class="item-title">
                        <span>${product.title} ${variant.title}</span>
                        ${isEssential ? `
                            <span class="essential-item__tag">
                                <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M15.8101 5.79558C15.7316 5.53688 15.496 5.35427 15.2133 5.32384L10.8473 4.8521L9.02548 0.971663C8.7899 0.484706 7.95753 0.484706 7.73766 0.971663L5.91586 4.8521L1.54984 5.32384C1.26715 5.35427 1.04728 5.53688 0.953044 5.79558C0.874519 6.05427 0.937339 6.32818 1.15721 6.51079L4.40817 9.38688L3.51298 13.5717C3.45016 13.8304 3.5601 14.1043 3.79567 14.2717C4.01554 14.4238 4.32965 14.4391 4.56522 14.3173L8.38157 12.2021L12.1979 14.3021C12.3079 14.363 12.4335 14.3934 12.5434 14.3934C12.6848 14.3934 12.8418 14.3477 12.9675 14.2564C13.1873 14.1043 13.2973 13.8304 13.2502 13.5564L12.3707 9.38688L15.6059 6.52601C15.8101 6.3434 15.8886 6.05427 15.8101 5.79558ZM11.1143 8.64123C10.9258 8.80862 10.8473 9.0521 10.8944 9.28036L11.5383 12.3543L8.72708 10.8173C8.61715 10.7564 8.49151 10.726 8.38157 10.726C8.27163 10.726 8.14599 10.7564 8.03606 10.8173L5.22484 12.3543L5.86875 9.28036C5.91586 9.03688 5.83734 8.7934 5.64888 8.64123L3.2617 6.52601L6.48125 6.17601C6.73253 6.14558 6.9367 5.9934 7.04663 5.78036L8.38157 2.91949L9.71651 5.78036C9.82644 5.9934 10.0306 6.14558 10.2819 6.17601L13.5014 6.52601L11.1143 8.64123Z" fill="white" stroke="#E69D2E" stroke-width="0.2"/>
                                </svg>
                            REQUIRED</span>
                        ` : ''}
                    </div>
                    <div class="item-amount">
                        <div class="item-price">$${variant.price}</div>
                        <div class="item-quantity">
                            <div class="product-quantity-input">
                                <button data-id="${variant.id}" class="product-quantity-adjust product-quantity-input-minus" type="button">&minus;</button>
                                <input type="number" id="updates_${variant.id}" pattern="[0-9]*" aria-label="quantity" data-id="${variant.id}" value="1" class="product-quantity-number schoolpack-product-qty-input">
                                <button data-id="${variant.id}" class="product-quantity-adjust product-quantity-input-plus" type="button">+</button>
                            </div>
                        </div>
                    </div>
                `;
                this.searchResultItems.appendChild(searchResultItemVariant);
            });
        } else {
            // Add product with single variant
            searchResultItem.innerHTML = `
                <div class="item-image">
                    <img src="${productImage}" alt="${productTitle}" width="100" height="100">
                </div>
                <div class="item-title">
                    <span>${productTitle}</span>
                    ${isEssential ? `
                        <span class="essential-item__tag">
                            <svg width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.8101 5.79558C15.7316 5.53688 15.496 5.35427 15.2133 5.32384L10.8473 4.8521L9.02548 0.971663C8.7899 0.484706 7.95753 0.484706 7.73766 0.971663L5.91586 4.8521L1.54984 5.32384C1.26715 5.35427 1.04728 5.53688 0.953044 5.79558C0.874519 6.05427 0.937339 6.32818 1.15721 6.51079L4.40817 9.38688L3.51298 13.5717C3.45016 13.8304 3.5601 14.1043 3.79567 14.2717C4.01554 14.4238 4.32965 14.4391 4.56522 14.3173L8.38157 12.2021L12.1979 14.3021C12.3079 14.363 12.4335 14.3934 12.5434 14.3934C12.6848 14.3934 12.8418 14.3477 12.9675 14.2564C13.1873 14.1043 13.2973 13.8304 13.2502 13.5564L12.3707 9.38688L15.6059 6.52601C15.8101 6.3434 15.8886 6.05427 15.8101 5.79558ZM11.1143 8.64123C10.9258 8.80862 10.8473 9.0521 10.8944 9.28036L11.5383 12.3543L8.72708 10.8173C8.61715 10.7564 8.49151 10.726 8.38157 10.726C8.27163 10.726 8.14599 10.7564 8.03606 10.8173L5.22484 12.3543L5.86875 9.28036C5.91586 9.03688 5.83734 8.7934 5.64888 8.64123L3.2617 6.52601L6.48125 6.17601C6.73253 6.14558 6.9367 5.9934 7.04663 5.78036L8.38157 2.91949L9.71651 5.78036C9.82644 5.9934 10.0306 6.14558 10.2819 6.17601L13.5014 6.52601L11.1143 8.64123Z" fill="white" stroke="#E69D2E" stroke-width="0.2"/>
                            </svg>
                        REQUIRED</span>
                    ` : ''}
                </div>
                <div class="item-amount">
                    <div class="item-price">$${productPrice}</div>
                    <div class="item-quantity">
                        <div class="product-quantity-input">
                            <button data-id="${productId}" class="product-quantity-adjust product-quantity-input-minus" type="button">&minus;</button>
                            <input type="number" id="updates_${productId}" pattern="[0-9]*" aria-label="quantity" data-id="${productId}" value="1" class="product-quantity-number schoolpack-product-qty-input">
                            <button data-id="${productId}" class="product-quantity-adjust product-quantity-input-plus" type="button">+</button>
                        </div>
                    </div>
                </div>
            `;
            this.searchResultItems.appendChild(searchResultItem);
        }
    }

    // Set line item quantity
    setItemQuantity() {
        const decrementButtons = this.querySelectorAll('.product-quantity-input-minus');
        const incrementButtons = this.querySelectorAll('.product-quantity-input-plus');
        if (!decrementButtons.length || !incrementButtons.length) return false;
        
        decrementButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const item = button.closest('.school-result-item');
                this.setQuantityValue(item, 'decrement');
            });
        });
        incrementButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                const item = button.closest('.school-result-item');
                this.setQuantityValue(item, 'increment');
            });
        });

        // Calculate total when quantity input changes by manual input
        const productQuantityInputs = this.querySelectorAll('.schoolpack-product-qty-input');
        if (!productQuantityInputs.length) return false;
        productQuantityInputs.forEach(input => {
            input.addEventListener('change', (e) => {
                const item = input.closest('.school-result-item');
                item.dataset.productQuantity = e.target.value;
                this.calculateTotal();
            });
        });
    }

    // Set quantity input value
    setQuantityValue(item, source) {
        const quantityInput = item.querySelector('.product-quantity-number');
        const quantity = parseInt(quantityInput.value) || 0;
        let newQuantity = quantity;
        if (source === 'decrement') {
            if (quantity > 0) {
                newQuantity = quantity - 1;
            }
        } else if (source === 'increment') {
            newQuantity = quantity + 1;
        }

        quantityInput.value = newQuantity;
        item.dataset.productQuantity = newQuantity;
        quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
        this.calculateTotal();
    }

    // Calculate total price and quantity
    calculateTotal() {
        const totalProductList = this.querySelectorAll('.school-result-item');
        if (!totalProductList.length) return false;

        const totalPriceElement = this.querySelector('.total-price');
        const totalProductsQuantityElement = this.querySelector('.total-item');
        let totalPrice = 0;
        let totalProductQuantity = 0;
        
        totalProductList.forEach(item => {
            const productPrice = item.dataset.productPrice;
            const productQuantity = parseInt(item.dataset.productQuantity) || 0;

            if (productQuantity > 0) {
                this.addtocartItemsQuantity += 1;
                totalProductQuantity += 1;
                totalPrice += productPrice * productQuantity;
            }
        });

        // Show total price and quantity
        if (totalPriceElement) {
            totalPriceElement.innerHTML = `$${totalPrice.toFixed(2)}`;
        }
        if (totalProductsQuantityElement) {
            totalProductsQuantityElement.innerHTML = `${totalProductQuantity} Items Selected`;
        }

        // Show total price and quantity in sticky footer
        const stickyFooter = this.querySelector('.school-result-footer.sticky-footer');
        if (stickyFooter) {
            const stickyFooterTotalPriceElement = stickyFooter.querySelector('.total-price');
            const stickyFooterTotalProductsQuantityElement = stickyFooter.querySelector('.total-item');
            if (stickyFooterTotalPriceElement) {
                stickyFooterTotalPriceElement.innerHTML = `$${totalPrice.toFixed(2)}`;
            }
            if (stickyFooterTotalProductsQuantityElement) {
                stickyFooterTotalProductsQuantityElement.innerHTML = `${totalProductQuantity} Items Selected`;
            }
        }
    }

    fractionToNumber(value) {
        const [num, den] = value.split('/').map(Number);
        return num / den;
    }

    // Add All Selected to Cart
    addAllSelectedToCart() {
        const addAllATCButtons = this.querySelectorAll('.footer-button-atc');
        if (!addAllATCButtons.length) return false;

        addAllATCButtons.forEach(button => {
            button.addEventListener('click', (e) => {
                if (this.addtocartItemsQuantity === 0) return false;
                e.preventDefault();

                const addToCartItems = [];
                const essentialItem = this.querySelectorAll('.school-result-item.essential-item');
                const hasInvalidEssentialItemQuantity = [...essentialItem].some(item => {
                    return Number(item.dataset.productQuantity) < 1;
                });
                if (hasInvalidEssentialItemQuantity) {
                    alert('Please select a quantity for all essential items');
                    return false;
                }

                const searchResultItems = this.querySelectorAll('.school-result-item');
                searchResultItems.forEach(item => {
                    const productId = item.dataset.productId;
                    const productQuantity = item.dataset.productQuantity;

                    if (productQuantity > 0) {
                        addToCartItems.push({
                            id: productId,
                            quantity: productQuantity
                        });
                    }
                });

                if (addToCartItems.length === 0) return false;
                const finalAtcItems = addToCartItems.map(item => ({
                    id: item.id,
                    quantity: item.quantity
                }));

                // Add to Cart
                fetch('/cart/add.js', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify({ items: finalAtcItems })
                })
                .then(response => response.json())
                .then(data => {
                    ShopifyAPI.getCart(ajaxCart.load);
                    const cartIcon = document.querySelector('.site-header__cart');
                    if (cartIcon) {
                        cartIcon.click();
                    }
                })
                .catch(error => {
                    console.error("Error adding to cart:", error);
                });
            });
        });
    }

    // Cancel or Back/Return Button
    returnToSchoolSearch() {
        const cancelButton = this.querySelectorAll('.footer-button-cancel');
        const backButton = this.querySelectorAll('.button__previous');
        const sectionCollectionSearchSchools = this.querySelector('.section-collection-search-schoolpack');

        if (cancelButton.length) {
            cancelButton.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.collectionSchoolResults.classList.add('empty');
                    sectionCollectionSearchSchools.classList.remove('show-hidden');
                });
            });
        }
        
        if (backButton.length) {
            backButton.forEach(button => {
                button.addEventListener('click', (e) => {
                    e.preventDefault();
                    this.collectionSchoolResults.classList.add('empty');
                    sectionCollectionSearchSchools.classList.remove('show-hidden');
                });
            });
        }
    }

    // Show result section
    showSchoolPackResultSection() {
        // Hide search section
        const sectionCollectionSearchSchools = this.querySelector('.section-collection-search-schoolpack');
        sectionCollectionSearchSchools.classList.add('show-hidden');

        // Show result section
        if (this.collectionSchoolResults.classList.contains('empty')) {
            this.collectionSchoolResults.classList.remove('empty');
        }
    }

    // Show sticky footer
    showStickyFooter() {
        const originalFooter = this.querySelector('.school-result-footer');
        const stickyFooter = this.querySelector('.school-result-footer.sticky-footer');

        const isFooterInView = () => {
            const rect = originalFooter.getBoundingClientRect();
            return rect.bottom <= window.innerHeight && rect.top >= 0;
        }

        // Show/hide sticky footer on scroll
        const toggleStickyFooter = () => {
            if (isFooterInView()) {
                stickyFooter.classList.remove('show-sticky-footer');
            } else {
                stickyFooter.classList.add('show-sticky-footer');
            }
        }

        // Initial check
        toggleStickyFooter();

        // Listen to scroll and resize
        window.addEventListener('scroll', toggleStickyFooter);
        window.addEventListener('resize', toggleStickyFooter);
    }

}


if (!window.customElements.get('search-schoolpack')) {
    customElements.define('search-schoolpack', SearchSchoolpack);
}